import { render, staticRenderFns } from "./list-view.vue?vue&type=template&id=54c2aeb0&scoped=true&"
import script from "./list-view.vue?vue&type=script&lang=js&"
export * from "./list-view.vue?vue&type=script&lang=js&"
import style0 from "./list-view.vue?vue&type=style&index=0&id=54c2aeb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2aeb0",
  null
  
)

export default component.exports